<template>
  <span>
    <template v-if="editMode">
      <ValidationProvider
        v-slot="{ errors }"
        :name="placeholder"
        :rules="rules"
        :title="tooltip != null ? tooltip : 'Wybierz wartość z listy'"
      >
        <v-autocomplete
          :items="activeItems"
          :value="valueDictionaryEntryCode"
          @input="$emit('input', $event)"
          item-text="value"
          :title="placeholder"
          item-value="dictionaryEntryCode"
          :label="placeholder"
          :placeholder="placeholder"
          clearable
          :error-messages="errors"
          :return-object="returnObject"
          :disabled="disabled"
          outlined
          persistent-placeholder
          class="mb-1"
        />
      </ValidationProvider>
    </template>
    <template v-else>
      {{ dictionaryEntryValue }}
    </template>
  </span>
</template>

<script>
import { ValidationProvider } from "vee-validate";
export default {
  name: "DictionaryEntrySelector",
  components: { ValidationProvider },
  props: {
    value: {
      type: [String, Object],
      default: "",
    },
    dictionaryName: {
      type: String,
      default: "",
    },
    rules: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: true,
    },
    returnObject: {
      type: Boolean,
      default: true,
    },
    excludeEntries: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    tooltip() {
      if (this.value != null && this.value.value) return this.value.value;
      else return "";
    },
    valueDictionaryEntryCode() {
      if (this.value == null) return this.value;
      if (typeof this.value == "string") return this.value;
      else return this.value.dictionaryEntryCode;
    },
    dictionaryNameResolver() {
      if (this.dictionaryName) return this.dictionaryName;
      else if (this.valueDictionaryEntryCode) {
        let index = this.valueDictionaryEntryCode.indexOf("-");
        let name = this.valueDictionaryEntryCode.substring(0, index);
        return name;
      }
      return null;
    },

    activeItems() {
      let entries = this.$store.getters["dict/getEntries"](this.dictionaryName);
      return entries.filter(
        (x) => this.excludeEntries.indexOf(x.dictionaryEntryCode) < 0
      );
    },
    placeholder() {
      return this.$store.getters["dict/getDictionaryValue"](
        this.dictionaryName
      );
    },
    dictionaryEntryValue() {
      if (this.dictionaryNameResolver && this.valueDictionaryEntryCode) {
        let entry = this.$store.getters["dict/getEntry"]({
          dictionaryCode: this.dictionaryNameResolver,
          dictionaryEntryCode: this.valueDictionaryEntryCode,
        });

        if (entry) return entry.value;
      }

      return "";
    },
  },

  watch: {
    dictionaryName: function(value) {
      if (value) this.loadDictionary(value);
    },
  },
  methods: {
    loadDictionary(dictionaryName) {
      this.$store.dispatch("dict/lazyLoad", {
        dictionaryCode: dictionaryName,
        archival: false,
      });
    },
  },

  created() {
    if (this.dictionaryNameResolver)
      this.loadDictionary(this.dictionaryNameResolver);
  },
};
</script>
